export default __webpack_public_path__ + "static/media/HAB1.6d5be93c.webp";